import { commonStyles, disabledCommonStyles, errorCommonStyles } from '../commonStyles';
import { InputRelatedStateType, InputRelatedVariantType } from '../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [InputRelatedVariantType.REGULAR]: {
            [InputRelatedStateType.DEFAULT_EMPTY]: {
                ...commonStyles(FOUNDATIONS, FONT),
            },
            [InputRelatedStateType.DEFAULT_FILLED]: {
                ...commonStyles(FOUNDATIONS, FONT),
                inputContainer: {
                    ...commonStyles(FOUNDATIONS, FONT).inputContainer,
                    border_color: FOUNDATIONS.color_accent_active_primary_border_50,
                },
            },
            [InputRelatedStateType.ACTIVE_EMPTY]: {
                ...commonStyles(FOUNDATIONS, FONT),
                inputContainer: {
                    ...commonStyles(FOUNDATIONS, FONT).inputContainer,
                    border_color: FOUNDATIONS.color_comp_forms_input_filled_border,
                },
            },
            [InputRelatedStateType.ACTIVE_FILLED]: {
                ...commonStyles(FOUNDATIONS, FONT),
                inputContainer: {
                    ...commonStyles(FOUNDATIONS, FONT).inputContainer,
                    border_width: FOUNDATIONS.border_100,
                    border_color: FOUNDATIONS.color_comp_forms_input_active_border,
                },
            },
            [InputRelatedStateType.ERROR_EMPTY]: {
                ...errorCommonStyles(FOUNDATIONS, FONT),
            },
            [InputRelatedStateType.ERROR_FILLED]: {
                ...errorCommonStyles(FOUNDATIONS, FONT),
                inputContainer: {
                    ...errorCommonStyles(FOUNDATIONS, FONT).inputContainer,
                    background_color: FOUNDATIONS.color_comp_forms_input_error_filled_bg,
                },
            },
            [InputRelatedStateType.DISABLED_EMPTY]: {
                ...disabledCommonStyles(FOUNDATIONS, FONT),
            },
            [InputRelatedStateType.DISABLED_FILLED]: {
                ...disabledCommonStyles(FOUNDATIONS, FONT),
            },
        },
    };
};
//# sourceMappingURL=regular.js.map